var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAiFileIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 2.86719C12.979 2.86719 11.6875 1.5835 11.6875 0H2.5C1.94772 0 1.5 0.447715 1.5 1V15C1.5 15.5523 1.94772 16 2.5 16H13.5625C14.1148 16 14.5625 15.5523 14.5625 15V2.86719Z",
    fill: "url(#paint0_linear_1120_126744)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 2.875C12.9747 2.875 11.6875 1.58782 11.6875 0Z",
    fill: "#FFC89C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_126744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98193 6.77581C9.98193 6.73338 9.99405 6.7152 10.0425 6.7152H10.7759C10.8183 6.7152 10.8365 6.72732 10.8365 6.77581V10.4546C10.8365 10.497 10.8244 10.5152 10.7759 10.5152H10.0486C10.0001 10.5152 9.98799 10.491 9.98799 10.4546L9.98193 6.77581ZM9.93344 5.72126C9.93344 5.42429 10.1456 5.24854 10.4062 5.24854C10.691 5.24854 10.8789 5.44247 10.8789 5.72126C10.8789 6.03035 10.6789 6.19399 10.3941 6.19399C10.1213 6.20005 9.93344 6.03035 9.93344 5.72126ZM7.83041 8.30914C7.70314 7.79399 7.39405 6.66672 7.27284 6.12126H7.26072C7.16375 6.66672 6.91526 7.58793 6.71526 8.30914H7.83041ZM6.53344 9.06672L6.16375 10.4667C6.15163 10.5091 6.1395 10.5152 6.09102 10.5152H5.41223C5.36375 10.5152 5.35163 10.5031 5.36375 10.4425L6.69102 5.80611C6.71526 5.72732 6.73344 5.64854 6.7395 5.41823C6.7395 5.38187 6.75163 5.36975 6.78193 5.36975H7.75769C7.79405 5.36975 7.80617 5.38187 7.81829 5.41823L9.30314 10.4485C9.31526 10.491 9.30314 10.5091 9.26072 10.5091H8.48496C8.44253 10.5091 8.42435 10.497 8.41223 10.4667L8.02435 9.06672C8.03041 9.07278 6.53344 9.06672 6.53344 9.06672Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1120_126744",
    x1: 8.03125,
    y1: 0,
    x2: 8.03125,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A4A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_126744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.06061,
    height: 6.06061,
    fill: "white",
    transform: "translate(5.09082 4.84863)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAiFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ai-file-icon.997f28fe1dd885a7800444eaf32552e4.svg";